<template>
  <div>
    <PageHeader title="Banners" :items="[{ text: 'Início', href: '/' }, { text: 'Banners', active: true }]" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <Table
            @open-new-banner="openNewBanner"
            @open-banner-details="openBannerDetails"
            @open-sales-banner-details="openSalesBannerDetails"
          />
        </div>
      </div>
    </div>
    <ModalDetails :payload="payload" />
    <ModalDetailsSales />
    <ModalDetailsSalesView :payload="salesPayload" />
  </div>
</template>

<script>
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import ModalDetails from './modal-details.vue'
import ModalDetailsSales from './modal-details-sales.vue'
import ModalDetailsSalesView from './modal-details-sales-view.vue'
import Table from './table.vue'

export default {
  name: 'BannersList',
  page: {
    title: 'Banners',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader, ModalDetails, ModalDetailsSales, ModalDetailsSalesView, Table },
  data() {
    return {
      payload: {},
      salesPayload: {},
      tabIndex: 0
    }
  },
  methods: {
    openNewBanner(data) {
      if (data && data.target === 'sales') {
        this.$bvModal.show('details-sales')
        return
      }
      this.payload = data
      this.$bvModal.show('details')
    },
    openBannerDetails(id) {
      this.$store.dispatch('showBanner', id)
        .then(res => {
          this.payload = res.sucssess
          this.$bvModal.show('details')
        })
    },
    openSalesBannerDetails(id) {
      this.$store.dispatch('showSalesBanner', id)
        .then(res => {
          this.salesPayload = res
          this.$bvModal.show('details-sales-view')
        })
        .catch(() => {
          this.$bvToast.toast('Nao foi possivel carregar o banner do Sales.', {
            variant: 'danger',
            title: 'Erro ao carregar',
            autoHideDelay: 5000
          })
        })
    }
  }
}
</script>

<style lang="scss">
.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.tab-content {
  padding: 0 !important;
}

.card-box {
  border-radius: 0 0 3px 3px;
}
</style>
